module.exports = __webpack_public_path__ + "img/ez-slot-guitar-card.85e8d3fa.png";